import { render } from "./ValidationErrorModal.vue?vue&type=template&id=7064c1d4&scoped=true"
import script from "./ValidationErrorModal.vue?vue&type=script&lang=js"
export * from "./ValidationErrorModal.vue?vue&type=script&lang=js"

import "./ValidationErrorModal.vue?vue&type=style&index=0&id=7064c1d4&scoped=true&lang=css"
import "./ValidationErrorModal.vue?vue&type=style&index=1&id=7064c1d4&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7064c1d4"]])

export default __exports__